"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyCalendar;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const react_native_calendars_1 = require("react-native-calendars");
const CompanyCalendar_1 = __importDefault(require("../api/CompanyCalendar"));
const CompanyCalendarCard_1 = require("../partials/CompanyCalendarCard");
const Screen_1 = __importDefault(require("../components/Screen"));
const Helper_1 = require("../Helper");
const ActionMenuButton_1 = __importDefault(require("../components/ActionMenuButton"));
const Button_1 = __importDefault(require("../components/Button"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const moment_1 = __importDefault(require("moment"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        filterLabel: {
            flexDirection: 'row',
            marginVertical: 4,
            paddingHorizontal: 4,
            flex: 1,
            alignItems: 'center'
        },
        filterLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500',
            flexWrap: 'wrap'
        },
        section: {
            backgroundColor: THEME.CardBackground,
            color: THEME.TextLight,
            marginTop: 12,
            paddingHorizontal: 8,
            borderRadius: 4,
            textTransform: 'capitalize',
            width: size != 'sm' ? 167 : undefined,
            paddingTop: 8,
            marginBottom: 8,
        },
        grid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignContent: 'center'
        },
        filterButton: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 6,
            paddingHorizontal: 6,
            flexBasis: '23%',
            flexGrow: 1,
            flexShrink: 1
        },
        label: {
            fontSize: 13,
            fontWeight: '600',
            flex: 1,
            lineHeight: 18
        }
    });
};
function CompanyCalendar(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const ChartColors = (0, Theme_1.useChartColors)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [refreshKey, setRefreshKey] = react_1.default.useState(0);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [backgroundStatus, setBackgroundStatus] = react_1.default.useState('');
    const [backgroundData, setBackgroundData] = react_1.default.useState([]);
    const [agendaListSections, setAgendaListSections] = react_1.default.useState([]);
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;
    const [currentMonth, setCurrentMonth] = react_1.default.useState((new Date().getMonth() + 1).toString().padStart(2, "0"));
    const [currentYear, setCurrentYear] = react_1.default.useState(new Date().getFullYear().toString());
    const [startDay, setStartDay] = react_1.default.useState(null);
    const [endDay, setEndDay] = react_1.default.useState(null);
    const [startDate, setStartDate] = react_1.default.useState(null);
    const [endDate, setEndDate] = react_1.default.useState(null);
    const sdate = { color: ChartColors[0] };
    const pdate = { color: ChartColors[1] };
    const hdate = { color: ChartColors[2] };
    const bdate = { color: ChartColors[3] };
    const holdate = { color: ChartColors[4] };
    const mdate = { color: ChartColors[5] };
    const cdate = { color: ChartColors[7] };
    const benefits = { color: ChartColors[9] };
    const [filters, setFilters] = react_1.default.useState({
        payrollDue: true,
        payDays: true,
        workAnniversaries: true,
        birthdays: true,
        bankHolidays: true,
        maintenance: true,
        customEvents: true,
        benefits: true
    });
    const filterCategories = [
        {
            id: 'payrollDue',
            label: t('company:text.submissionsDue'),
            color: sdate.color,
            bgColor: `${sdate.color}80`
        },
        {
            id: 'payDays',
            label: t('company:text.payDays'),
            color: pdate.color,
            bgColor: `${pdate.color}80`
        },
        {
            id: 'benefits',
            label: t('company:text.benefits'),
            color: benefits.color,
            bgColor: `${benefits.color}80`
        },
        {
            id: 'workAnniversaries',
            label: t('company:text.workAnniversaries'),
            color: hdate.color,
            bgColor: `${hdate.color}80`
        },
        {
            id: 'birthdays',
            label: t('company:text.birthdays'),
            color: bdate.color,
            bgColor: `${bdate.color}80`
        },
        {
            id: 'bankHolidays',
            label: t('company:text.bankHolidays'),
            color: holdate.color,
            bgColor: `${holdate.color}80`
        },
        {
            id: 'maintenance',
            label: t('company:text.maintenance'),
            color: mdate.color,
            bgColor: `${mdate.color}80`
        },
        {
            id: 'customEvents',
            label: t('company:text.customEvents'),
            color: cdate.color,
            bgColor: `${cdate.color}80`
        }
    ];
    const toggleFilter = (id) => {
        setFilters(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };
    const actionsList = react_1.default.useMemo(() => filterCategories.map(cat => {
        const key = cat.id;
        const isActive = filters[key];
        return {
            label: cat.label,
            icon: isActive ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square,
            iconColor: cat.color,
            iconSize: 20,
            onPress: () => setFilters(prev => ({
                ...prev,
                [key]: !prev[key],
            })),
        };
    }), [filters, filterCategories, Theme_1.ICONS]);
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshKey(Math.random());
    }, []);
    const weekDayOptions = [
        { label: t('company:text.sunday'), value: "sunday", short: "D" },
        { label: t('company:text.monday'), value: "monday", short: "L" },
        { label: t('company:text.tuesday'), value: "tuesday", short: "M" },
        { label: t('company:text.wednesday'), value: "wednesday", short: "X" },
        { label: t('company:text.thursday'), value: "thursday", short: "J" },
        { label: t('company:text.friday'), value: "friday", short: "V" },
        { label: t('company:text.saturday'), value: "saturday", short: "S" }
    ];
    const weekOfMonthOptions = [
        { label: t('company:text.firstWeek'), value: "1" },
        { label: t('company:text.secondWeek'), value: "2" },
        { label: t('company:text.thirdWeek'), value: "3" },
        { label: t('company:text.fourthWeek'), value: "4" },
        { label: t('company:text.lastWeek'), value: "5" },
    ];
    const getDayLabel = (date) => {
        return date ? weekDayOptions[date.getUTCDay()]?.label : undefined;
    };
    function getDaySuffix(day) {
        if (10 <= day % 100 && day % 100 <= 20) {
            return `${day}${t('company:text.fourthSuffix')}`;
        }
        const suffixes = [t('company:text.firstSuffix'), t('company:text.secondSuffix'), t('company:text.thirdSuffix')];
        const suffix = suffixes[(day % 10) - 1] || t('company:text.fourthSuffix');
        return `${day}${suffix}`;
    }
    const getMonthlyPattern = (startDate, endDate, recurrenceMonthlyMode, recurrenceMonthlyOrdinal) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return null;
        }
        if (recurrenceMonthlyMode == 'dayOfMonth') {
            return start.getTime() !== end.getTime() ? `${t('company:text.from').toLowerCase()} ${getDaySuffix(start.getUTCDate())} ${t('company:text.toThe')} ${getDaySuffix(end.getUTCDate())}` : `${t('company:text.onTheDay').toLowerCase()} ${getDaySuffix(start.getUTCDate())}`;
        }
        else if (recurrenceMonthlyMode == 'weekday') {
            const daysLabel = start.getTime() !== end.getTime() ? getDayLabel(start) + ' - ' + getDayLabel(end) : getDayLabel(start);
            const weekLabel = weekOfMonthOptions.find(w => w.value === recurrenceMonthlyOrdinal)?.label.toLowerCase() ?? '';
            return `${t('company:text.onThe').toLowerCase()} ${weekLabel} ${daysLabel}`;
        }
        return null;
    };
    const getWeeklyPattern = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return null;
        }
        const daysLabel = start.getTime() !== end.getTime() ? getDayLabel(start) + ' - ' + getDayLabel(end) : getDayLabel(start);
        return `${t('company:text.on').toLowerCase()} ${daysLabel}`;
    };
    const processData = (data) => {
        data.forEach((section) => {
            section.colors = [];
            // Replace API placeholders with translated text and add colors to days
            section.data.forEach((item) => {
                if (item.type == 'bdate') {
                    item.title = item.title.replace('bdate', t('company:text.birthday'));
                    item.color = bdate.color;
                    if (!section.colors.includes(bdate))
                        section.colors.push(bdate);
                }
                if (item.type == 'hdate') {
                    item.title = item.title.replace('hdate', t('company:text.workAnniversary'));
                    item.title = item.title.replace('yrs', t('company:text.yrs'));
                    item.color = hdate.color;
                    if (!section.colors.includes(hdate))
                        section.colors.push(hdate);
                }
                if (item.type == 'pdate') {
                    item.title = item.title.replace('pdate', t('company:text.payDay'));
                    item.color = pdate.color;
                    if (!section.colors.includes(pdate))
                        section.colors.push(pdate);
                }
                if (item.type == 'benefits') {
                    item.title = item.title;
                    item.color = benefits.color;
                    if (!section.colors.includes(benefits))
                        section.colors.push(benefits);
                }
                if (item.type == 'sdate') {
                    item.title = item.title.replace('sdate', t('company:text.submissionDue'));
                    if (item.subtitleTimes?.length > 0) {
                        let timeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                        item.subtitle = t('company:text.submissionTime') + ' ' + timeStr;
                    }
                    item.color = sdate.color;
                    if (!section.colors.includes(sdate))
                        section.colors.push(sdate);
                }
                if (item.type == 'holdate') {
                    item.title = item.title.replace('holdate', t('company:text.bankHoliday'));
                    item.color = holdate.color;
                    if (!section.colors.includes(holdate))
                        section.colors.push(holdate);
                }
                if (item.type == 'mdate') {
                    item.title = item.title.replace('mdate', t('company:text.maintenance'));
                    if (item.subtitle) {
                        if (item.subtitle.includes('mdatestart') && item.subtitle.includes('mdateend')) {
                            if (item.subtitleTimes?.length > 1) {
                                let startTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                let endTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[1]);
                                item.subtitle = t('common:text.starts') + ' ' + startTimeStr + ', ' + t('common:text.ends') + ' ' + endTimeStr;
                            }
                        }
                        else if (item.subtitle.includes('mdatestart')) {
                            if (item.subtitleTimes?.length > 0) {
                                let startTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                item.subtitle = t('common:text.starts') + ' ' + startTimeStr;
                            }
                        }
                        else {
                            if (item.subtitleTimes?.length > 0) {
                                let endTimeStr = Helper_1.Helper.FormatTime(item.subtitleTimes[0]);
                                item.subtitle = t('common:text.ends') + ' ' + endTimeStr;
                            }
                        }
                    }
                    item.color = mdate.color;
                    if (!section.colors.includes(mdate))
                        section.colors.push(mdate);
                }
                if (item.type == 'cdate') {
                    item.title = item.title.replace('cdate', t('company:text.customEvents'));
                    item.color = cdate.color;
                    if (item.subtitle) {
                        let subtitleOriginal = item.subtitle;
                        item.subtitle = '';
                        let startDate = '';
                        let endDate = '';
                        let startTimeStr = '';
                        let endTimeStr = '';
                        if (item.subtitleTimes?.length > 1) {
                            startDate = item.subtitleTimes[0];
                            endDate = item.subtitleTimes[1];
                            startTimeStr = Helper_1.Helper.FormatDate(startDate);
                            endTimeStr = Helper_1.Helper.FormatDate(endDate);
                            item.subtitle = (subtitleOriginal.includes('cdatestart') && subtitleOriginal.includes('cdateend') && !subtitleOriginal.includes('recurrence')) ? t('common:text.starts') + ' ' + startTimeStr + ' | ' + t('common:text.ends') + ' ' + endTimeStr : '';
                        }
                        if (subtitleOriginal.includes('recurrence')) {
                            if (item.subtitleRecurrence?.length > 0) {
                                let recurrenceType = item.subtitleRecurrence[0];
                                let recurrenceMonthlyMode = '';
                                let recurrenceMonthlyOrdinal = '';
                                if (item.subtitleRecurrence?.length > 1)
                                    recurrenceMonthlyMode = item?.subtitleRecurrence[1];
                                if (item.subtitleRecurrence?.length == 3)
                                    recurrenceMonthlyOrdinal = item?.subtitleRecurrence[2];
                                let recurrenceDay = '';
                                switch (recurrenceType) {
                                    case 'weekly':
                                        recurrenceType = t('company:text.weekly');
                                        recurrenceDay = `${getWeeklyPattern(startDate, endDate)}`;
                                        break;
                                    case 'biweekly':
                                        recurrenceType = t('company:text.biweekly');
                                        recurrenceDay = `${getWeeklyPattern(startDate, endDate)}`;
                                        break;
                                    case 'monthly':
                                        recurrenceType = t('company:text.monthly');
                                        recurrenceDay = `${getMonthlyPattern(startDate, endDate, recurrenceMonthlyMode, recurrenceMonthlyOrdinal)}`;
                                        break;
                                    case 'annually':
                                        recurrenceType = t('company:text.annually');
                                        break;
                                    default:
                                        recurrenceType = '';
                                        recurrenceDay = '';
                                }
                                item.subtitle += recurrenceType + ' ' + recurrenceDay;
                            }
                        }
                        if (subtitleOriginal.includes('end')) {
                            if (item.subtitleRecurrenceEnd?.length == 2) {
                                let recurrenceEndMode = item.subtitleRecurrenceEnd[0]; //never, onDate, afterCount
                                let recurrenceEndModeValue = item.subtitleRecurrenceEnd[1]; // empty if never, date if onDate, count if afterCount
                                if (recurrenceEndMode == 'onDate') {
                                    let endDateStr = Helper_1.Helper.FormatDate(recurrenceEndModeValue);
                                    item.subtitle += ' | ' + t('company:text.endsOn') + ' ' + endDateStr;
                                }
                                else if (recurrenceEndMode == 'afterCount') {
                                    item.subtitle += ' | ' + t('company:text.repeatsFor') + ' ' + recurrenceEndModeValue + ' ' + t('company:text.recurrenceOccurrences');
                                }
                                else if (recurrenceEndMode == 'never') {
                                    item.subtitle += ' | ' + t('company:text.repeatsForever');
                                }
                                // no addition for never
                            }
                        }
                    }
                    if (!section.colors.includes(cdate))
                        section.colors.push(cdate);
                }
            });
            if (section.data.length == 0)
                section.data = [{ title: '', type: 'noevents', color: null }];
        });
        return data;
    };
    const runBackgroundFetch = () => {
        setBackgroundStatus('backgroundLoading');
        userContext.getToken()
            .then((token) => {
            CompanyCalendar_1.default.getCompanyDates(token).then((data) => {
                let bgData = processData(data);
                setBackgroundData(bgData);
                setBackgroundStatus('backgroundReady');
            });
        })
            .catch((err) => {
            setBackgroundStatus('backgroundError');
        });
    };
    const refresh = react_1.default.useCallback((forceRefresh = false) => {
        if (backgroundStatus === 'backgroundReady' && !forceRefresh)
            return;
        if (backgroundStatus === 'backgroundError' || backgroundStatus === '')
            runBackgroundFetch();
        promise.current?.cancel();
        setStatus('loading');
        const p = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => CompanyCalendar_1.default.getCompanyDates(token, Number(currentMonth), Number(currentYear))));
        promise.current = p;
        p.then((data) => {
            data = processData(data);
            setAgendaListSections(data);
            setStatus('done');
        })
            .catch((e) => {
            if (e?.isCanceled)
                return;
            setAgendaListSections([]);
            setStatus('error');
        });
    }, [currentMonth, currentYear]);
    const refreshRef = react_1.default.useRef(refresh);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, [refresh]);
    // Update the refresh ref updated for the device event emitter
    react_1.default.useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);
    const handleAddEdit = react_1.default.useCallback((customEvent) => {
        react_native_1.DeviceEventEmitter.emit("event.hideSnackbar");
        props.navigation.navigate('CalendarEventEdit', {
            id: customEvent?.id ?? '',
            startDate: startDate,
            endDate: endDate ?? startDate
        });
    }, [startDate, endDate]);
    const renderItem = react_1.default.useCallback(({ item }) => {
        return (0, jsx_runtime_1.jsx)(CompanyCalendarCard_1.AgendaItem, { item: item, onEditPress: () => { handleAddEdit(item); }, itemColorEnabled: true });
    }, []);
    react_1.default.useEffect(() => {
        const subscription = react_native_1.DeviceEventEmitter.addListener('event.calendarEventUpdate', () => {
            setBackgroundStatus('');
            refreshRef.current(true);
        });
        return () => {
            subscription.remove();
        };
    }, []);
    const displayDates = react_1.default.useMemo(() => {
        const noEventsFilter = 'noevents';
        const sdateFilter = filters.payrollDue ? 'sdate' : null;
        const pdateFilter = filters.payDays ? 'pdate' : null;
        const bdateFilter = filters.birthdays ? 'bdate' : null;
        const hdateFilter = filters.workAnniversaries ? 'hdate' : null;
        const bhdateFilter = filters.bankHolidays ? 'holdate' : null;
        const mdateFilter = filters.maintenance ? 'mdate' : null;
        const cdateFilter = filters.customEvents ? 'cdate' : null;
        const benefitsFilter = filters.benefits ? 'benefits' : null;
        const sdateColorFilter = filters.payrollDue ? sdate.color : null;
        const pdateColorFilter = filters.payDays ? pdate.color : null;
        const bdateColorFilter = filters.birthdays ? bdate.color : null;
        const hdateColorFilter = filters.workAnniversaries ? hdate.color : null;
        const bhdateColorFilter = filters.bankHolidays ? holdate.color : null;
        const mdateColorFilter = filters.maintenance ? mdate.color : null;
        const cdateColorFilter = filters.customEvents ? cdate.color : null;
        const benefitsColorFilter = filters.benefits ? benefits.color : null;
        let result = JSON.parse(JSON.stringify(agendaListSections));
        result = result.filter((section) => section.title.split('-')[0] == currentYear && section.title.split('-')[1] == currentMonth);
        // Filter the sections that match the toggles
        result = result?.filter((s) => s.data.length == 0 ||
            s.data.some((item) => item.type == sdateFilter ||
                item.type == pdateFilter ||
                item.type == bdateFilter ||
                item.type == hdateFilter ||
                item.type == bhdateFilter ||
                item.type == mdateFilter ||
                item.type == cdateFilter ||
                item.type == benefitsFilter ||
                item.type == noEventsFilter));
        // filter data/colors
        result.forEach((section) => {
            section.data = section.data.filter((item) => item.type == sdateFilter ||
                item.type == pdateFilter ||
                item.type == bdateFilter ||
                item.type == hdateFilter ||
                item.type == bhdateFilter ||
                item.type == mdateFilter ||
                item.type == cdateFilter ||
                item.type == benefitsFilter ||
                item.type == noEventsFilter);
            section.colors = section.colors.filter((color) => color.color == sdateColorFilter ||
                color.color == pdateColorFilter ||
                color.color == bdateColorFilter ||
                color.color == hdateColorFilter ||
                color.color == bhdateColorFilter ||
                color.color == mdateColorFilter ||
                color.color == benefitsColorFilter ||
                color.color == cdateColorFilter);
        });
        return result;
    }, [
        agendaListSections,
        currentYear,
        currentMonth,
        filters,
        sdate.color,
        pdate.color,
        bdate.color,
        hdate.color,
        holdate.color,
        mdate.color,
        cdate.color,
        benefits.color
    ]);
    const isDark = (0, ThemeContext_1.useIsDark)();
    // markedDates considering displayDates + range
    const markedDates = react_1.default.useMemo(() => {
        const md = {};
        // dots
        displayDates.forEach((section) => {
            if (section.data && section.data.length > 0)
                md[section.title] = { dots: section.colors, marked: true };
            else
                md[section.title] = { disabled: true };
        });
        // selection overlay
        if (startDay) {
            const from = startDay;
            const to = endDay ?? startDay;
            const start = (0, moment_1.default)(from);
            const end = (0, moment_1.default)(to);
            for (const d = (0, moment_1.default)(start); d.isSameOrBefore(end); d.add(1, 'days')) {
                const key = d.format('YYYY-MM-DD');
                md[key] = {
                    ...(md[key] || {}),
                    selected: true,
                    selectedColor: THEME.PrimaryLightest,
                    selectedTextColor: THEME.Secondary,
                };
            }
        }
        return md;
    }, [displayDates, startDay, endDay, isDark]);
    const filteredSections = react_1.default.useMemo(() => {
        let from;
        let to;
        if (!startDay && !endDay) {
            return displayDates;
        }
        else if (startDay && !endDay) {
            from = startDay;
            to = startDay;
        }
        else if (startDay && endDay) {
            const s = startDay;
            const e = endDay;
            from = s < e ? s : e;
            to = s < e ? e : s;
        }
        else {
            from = todayStr;
            to = todayStr;
        }
        const result = displayDates.filter((section) => section.title >= from && section.title <= to);
        return result;
    }, [displayDates, startDay, endDay, todayStr]);
    const handleDayPress = (date) => {
        const clicked = date.dateString;
        if (!startDay || endDay) {
            setStartDay(clicked);
            setEndDay(null);
            const d = new Date(date.year, date.month - 1, date.day);
            setStartDate(d);
            setEndDate(null);
        }
        else {
            if ((0, moment_1.default)(clicked).isAfter((0, moment_1.default)(startDay))) {
                setStartDay(startDay);
                setEndDay(clicked);
                const toDate = new Date(date.year, date.month - 1, date.day);
                setStartDate(startDate);
                setEndDate(toDate);
            }
            else {
                // If click is before startDay, start a new selection
                setStartDay(clicked);
                setEndDay(null);
                const d = new Date(date.year, date.month - 1, date.day);
                setStartDate(d);
                setEndDate(null);
            }
        }
    };
    react_1.default.useEffect(() => {
        if (props.route?.params?.date) {
            let dateString = props.route.params.date;
            let dateSplit = dateString.split('-');
            if (dateSplit.length == 3) {
                handleDayPress({
                    dateString,
                    year: dateSplit[0],
                    month: dateSplit[1],
                    day: dateSplit[2]
                });
            }
        }
    }, []);
    const next = new Date(today);
    next.setFullYear(today.getFullYear() + 1);
    const maxDateObj = new Date(next.getFullYear(), 12, 0);
    const maxDate = maxDateObj.toISOString().slice(0, 10);
    const previous = new Date(today);
    previous.setFullYear(today.getFullYear() - 1);
    const minDateObj = new Date(previous.getFullYear(), 0, 1);
    const minDate = minDateObj.toISOString().slice(0, 10);
    const cardMargin = (size == 'sm' ? 8 : 16);
    const portalEnabled = userContext?.adminExperience == 'both' ||
        userContext?.adminExperience == 'elevate-edge';
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { onRefresh: onRefresh, scrollEnabled: size == 'sm', containerStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground,
            padding: 0
        } : { padding: 0 }, scrollStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground,
            flex: 1
        } : null, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                paddingVertical: size != 'sm' ? 0 : 0,
                borderWidth: 0,
                borderRadius: 4,
                margin: (portalEnabled ? (size != 'sm' ? cardMargin : 0) : (size != 'sm' ? -cardMargin : 0)),
                marginTop: (portalEnabled ? (size != 'sm' ? cardMargin : 0) : cardMargin),
                flex: 1,
                backgroundColor: size != 'sm' ? 'transparent' : THEME.White
            }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: size != 'sm' ? 'row' : 'column', alignItems: 'stretch', minHeight: 0, width: '100%', flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: size != 'sm' ? 2 : undefined, backgroundColor: 'transparent', alignSelf: size != 'sm' ? 'flex-start' : 'stretch' }, children: [(0, jsx_runtime_1.jsxs)(Card_1.default, { style: { flex: 3, ...(size != 'sm' ? { padding: 12, paddingBottom: 18 } : {}) }, children: [(0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { scrollEnabled: size != 'sm', children: (0, jsx_runtime_1.jsx)(react_native_calendars_1.Calendar, { hideExtraDays: true, headerStyle: { backgroundColor: THEME.PrimaryLightest, borderRadius: 6 }, displayLoadingIndicator: status == 'loading', markedDates: markedDates, markingType: 'multi-dot', maxDate: maxDate, minDate: minDate, disableArrowLeft: status == 'loading', disableArrowRight: status == 'loading', onDayPress: handleDayPress, arrowsHitSlop: 8, onMonthChange: (date) => {
                                                setStartDate(null);
                                                setEndDate(null);
                                                setStartDay(null);
                                                setEndDay(null);
                                                setCurrentMonth(date.month.toString().padStart(2, "0"));
                                                if (date.year.toString() != currentYear)
                                                    setCurrentYear(date.year.toString());
                                                if (backgroundStatus === 'backgroundReady') {
                                                    promise.current?.cancel();
                                                    setStatus('done');
                                                    setAgendaListSections(backgroundData);
                                                }
                                            }, renderArrow: direction => {
                                                return ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Text, icon: direction == 'right' ? Theme_1.ICONS.Regular.ChevronRight : Theme_1.ICONS.Regular.ChevronLeft }));
                                            }, theme: {
                                                selectedDayBackgroundColor: 'transparent',
                                                calendarBackground: THEME.CardBackground,
                                                selectedDayTextColor: THEME.Text,
                                                todayTextColor: THEME.Secondary,
                                                todayBackgroundColor: `${THEME.Secondary}11`,
                                                dayTextColor: THEME.Text,
                                                textDayFontSize: size != 'sm' ? 20 : 16,
                                                monthTextColor: THEME.Text,
                                                weekVerticalMargin: size != 'sm' ? 12 : 6,
                                                textMonthFontWeight: '500',
                                                textMonthFontSize: size != 'sm' ? 20 : 18,
                                                textDisabledColor: THEME.TextDisabled,
                                                indicatorColor: THEME.Secondary,
                                            } }, `calendar-${isDark ? "dark" : "light"}`) }), size == 'sm' &&
                                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [size != 'sm' ? STYLES.cardLandscape : STYLES.cardPortait, size != 'sm' ? {} : { marginHorizontal: 12, marginVertical: 6 }], children: (0, jsx_runtime_1.jsx)(ActionMenuButton_1.default, { actionsList: actionsList, label: t('company:text.filter'), buttonType: 'outline', buttonStyle: { marginTop: 22, marginBottom: 4 }, leadingIcon: Theme_1.ICONS.Regular.Filter, showTrailingChevron: false, menuItemTextStyle: { marginTop: 4 }, stayOpen: true }) })] }), size != 'sm' &&
                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [size != 'sm' ? STYLES.cardLandscape : STYLES.cardPortait, size != 'sm' ? {} : { marginHorizontal: 12 }], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.grid, children: filterCategories.map((filter) => {
                                            const isActive = filters[filter.id];
                                            return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => toggleFilter(filter.id), style: ({ pressed }) => [
                                                    styles.filterButton,
                                                    { opacity: pressed ? 0.7 : 1 }
                                                ], role: 'checkbox', "aria-checked": isActive, accessibilityLabel: filter.label, accessibilityRole: 'checkbox', children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.filterLabel, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: isActive ? Theme_1.ICONS.Solid.SquareCheck : Theme_1.ICONS.Regular.Square, color: filter.color, size: 22, style: { marginHorizontal: 8 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.filterLabelText, children: filter.label })] }) }, filter.id));
                                        }) }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: size != 'sm' ? 500 : '100%', flex: 1, overflow: 'hidden', alignSelf: 'stretch', minWidth: 0, minHeight: 0 }, children: (0, jsx_runtime_1.jsxs)(Card_1.default, { style: {
                                flex: size != 'sm' ? 1 : undefined,
                                overflow: 'hidden',
                                minHeight: 0,
                                minWidth: 0,
                                ...(size != 'sm' ? { padding: 12 } : {})
                            }, children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('company:labels.agenda'), style: { padding: 8, backgroundColor: THEME.PrimaryLightest, borderRadius: 6, marginBottom: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', color: status === 'done' ? THEME.Primary : THEME.TextDisabled, accessibilityHint: t('common:buttons.add'), onPress: () => handleAddEdit(null), style: { alignSelf: 'flex-end' }, disabled: status !== 'done', children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: status === 'done' ? THEME.Primary : THEME.TextDisabled, icon: Theme_1.ICONS.Regular.Plus, size: 14 }) }) }), status === 'done' ? (size != 'sm' ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, minHeight: 0 }, children: (0, jsx_runtime_1.jsx)(react_native_calendars_1.AgendaList, { sections: filteredSections, renderItem: renderItem, sectionStyle: styles.section, style: { flex: 1, minHeight: 0 }, theme: {
                                            dayTextColor: THEME.Text,
                                            monthTextColor: THEME.Text,
                                            textDisabledColor: THEME.TextDisabled
                                        } }) })) : ((0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { horizontal: true, keyboardShouldPersistTaps: "handled", nestedScrollEnabled: true, showsVerticalScrollIndicator: true, bounces: false, persistentScrollbar: true, overScrollMode: "never", contentContainerStyle: {
                                        flex: 1,
                                        marginTop: 8
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_calendars_1.AgendaList, { sections: filteredSections, renderItem: renderItem, sectionStyle: styles.section, bounces: false, theme: {
                                            dayTextColor: THEME.Text,
                                            monthTextColor: THEME.Text,
                                            textDisabledColor: THEME.TextDisabled
                                        } }) }))) : ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }))] }) })] }) }, refreshKey) }));
}
;
